export const EVENT_TYPES = {
  OSCE: 1,
  PROOF: 2,
  TRAINING: 3,
} as const;

export const getEventTypeName = (
  type: number | string | null | undefined,
  t: (key: string) => string
): string => {
  if (type === null || type === undefined || type === "") return "—";
  switch (Number(type)) {
    case EVENT_TYPES.OSCE:
      return t("title_menu_item_osce");
    case EVENT_TYPES.PROOF:
      return t("title_menu_item_proof");
    case EVENT_TYPES.TRAINING:
      return t("title_menu_item_training");
    default:
      return "—";
  }
};
